module.exports = __webpack_public_path__ + "static/media/DE_Orddiktat.4e417372.mp4";